import type { LearningModule } from './learning-modules';
import type { Teacher } from './teacher';
import type { Site } from './site';
import type { Planning } from './planning';
import type { LearningProgram } from './learning-program';

export enum GroupStatus {
  Unconfirmed = 'Unconfirmed',
  Confirmed = 'Confirmed',
  Projected = 'Projected',
}

export interface GroupModuleSequence {
  id: string;
  moduleId: string;
  module?: LearningModule;
  startDate: string | null; // ISO date string, optional
  assignedTeacherId: string | null;
  assignedTeacher?: Teacher | null;
  numberOfHours?: number | null;
  sequenceOrder: number;
  workStudy: boolean;
  periodAffinity: string[];
}

export interface Group {
  id: string;
  name: string;
  planningId: string;
  planning?: Planning | null;
  learningProgramId: string;
  learningProgram?: LearningProgram | null;
  siteId?: string | null;
  site?: Site | null;
  cohortId?: string | null;
  archived: boolean;
  status: GroupStatus;
  isSmallGroup: boolean;
  memberCount: number;
}

export interface CreateGroupRequest {
  name: string;
  planningId: string;
  learningProgramId: string;
  siteId?: string | null;
  status?: GroupStatus;
  isSmallGroup?: boolean;
  cohortId?: string | null;
}

export interface UpdateGroupRequest {
  id: string;
  name: string;
  planningId: string;
  learningProgramId: string;
  siteId?: string | null;
  status: GroupStatus;
  isSmallGroup: boolean;
  archived?: boolean;
}

export interface UpdateGroupModuleSequenceItem {
  id: string;
  moduleId: string;
  startDate: string | null; // YYYY-MM-DD, optional
  numberOfHours?: number | null;
  sequenceOrder: number;
  workStudy: boolean;
  periodAffinity: string[];
}

export interface UpdateGroupModuleSequencesRequest {
  sequences: UpdateGroupModuleSequenceItem[];
}

export interface GroupModuleSequencesResponse {
  sequences: GroupModuleSequence[];
}

export interface GroupResponse {
  group: Group;
}

export interface GroupsResponse {
  groups: Group[];
}

export interface ActiveGroup {
  id: string;
  name: string;
  programId: string;
  programTitle: string;
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  studentCount: number;
}

export interface ActiveGroupsResponse {
  groups: ActiveGroup[];
}
